import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, onSnapshot, query } from 'firebase/firestore'; 

// --- Formatlama Fonksiyonları ---
function formatDate(timestamp) {
  if (!timestamp) return '---';
  const date = timestamp.toDate(); 
  return date.toLocaleDateString('tr-TR');
}
function formatCurrency(number) {
    if (typeof number !== 'number') return '---';
    return number.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
}
function formatMonthName(date) {
    const months = [
      "OCAK","ŞUBAT","MART","NİSAN","MAYIS","HAZİRAN",
      "TEMMUZ","AĞUSTOS","EYLÜL","EKİM","KASIM","ARALIK"
    ];
    return months[date.getMonth()];
}
// ---------------------------------

function AdminDashboard() {
  
  const [buAyTaksitler, setBuAyTaksitler] = useState([]); // GELİRLER
  const [buAyOdemeler, setBuAyOdemeler] = useState([]);   // GİDERLER
  
  // Bildirimler için (Sadece bekleyenleri saymak için)
  const [bekleyenTaksitSayisi, setBekleyenTaksitSayisi] = useState(0);
  const [bekleyenOdemeSayisi, setBekleyenOdemeSayisi] = useState(0);

  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); 
  
  const [now, setNow] = useState(new Date());
  const [alertOpen, setAlertOpen] = useState(false);
  const [paymentAlertOpen, setPaymentAlertOpen] = useState(false);

  const buAyAdi = formatMonthName(now);

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  // --- Veri Çekme ---
  useEffect(() => {
    const bugun = new Date();
    
    // Tüm verileri çekip JS tarafında filtreleyeceğiz (Daha güvenli)
    const qTaksitler = query(collection(db, "taksitler"));
    const qOdemeler = query(collection(db, "odemeler"));

    const unsubTaksitler = onSnapshot(qTaksitler, (querySnapshot) => {
      const tumTaksitler = [];
      querySnapshot.forEach((doc) => { tumTaksitler.push({ id: doc.id, ...doc.data() }); });
      
      // --- FİLTRELEME 1: BU AYIN TAHSİLATLARI (Hepsi: Ödendi + Bekliyor) ---
      const buAyListesi = tumTaksitler.filter(taksit => {
          const d = taksit.odemeGunu.toDate();
          return d.getMonth() === bugun.getMonth() && d.getFullYear() === bugun.getFullYear();
      });
      buAyListesi.sort((a, b) => a.odemeGunu.toDate() - b.odemeGunu.toDate());
      setBuAyTaksitler(buAyListesi);

      // Bildirim için sadece geçmiş ve bekleyenleri say
      const acilDurum = tumTaksitler.filter(t => t.durum === 'Bekliyor' && t.odemeGunu.toDate() <= bugun).length;
      setBekleyenTaksitSayisi(acilDurum);

      setLoading(false); 
    }, (err) => console.error(err));

    const unsubOdemeler = onSnapshot(qOdemeler, (querySnapshot) => {
      const tumOdemeler = [];
      querySnapshot.forEach((doc) => { tumOdemeler.push({ id: doc.id, ...doc.data() }); });

      // --- FİLTRELEME 2: BU AYIN GİDERLERİ (Hepsi) ---
      const buAyGiderListesi = tumOdemeler.filter(odeme => {
          const d = odeme.odemeTarihi.toDate();
          return d.getMonth() === bugun.getMonth() && d.getFullYear() === bugun.getFullYear();
      });
      buAyGiderListesi.sort((a, b) => a.odemeTarihi.toDate() - b.odemeTarihi.toDate());
      setBuAyOdemeler(buAyGiderListesi);

      // Bildirim için
      const acilOdeme = tumOdemeler.filter(o => o.durum === 'Bekliyor' && o.odemeTarihi.toDate() <= bugun).length;
      setBekleyenOdemeSayisi(acilOdeme);

    }, (err) => console.error(err));

    return () => { unsubTaksitler(); unsubOdemeler(); };
  }, []);

  const handleRowClick = (cariId) => { if (cariId) navigate(`/cariler/${cariId}`); };
  const handleTedarikciClick = (cariId) => { if (cariId) navigate(`/tedarikciler/${cariId}`); };

  // Duruma göre renk sınıfı
  const getStatusClass = (taksit) => {
      if (taksit.durum === 'Ödendi') return 'status-paid';
      if (taksit.odemeGunu.toDate() < new Date()) return 'status-overdue';
      return 'status-pending';
  };

  const getGiderStatusClass = (odeme) => {
    if (odeme.durum === 'Ödendi') return 'status-paid';
    if (odeme.odemeTarihi.toDate() < new Date()) return 'status-overdue';
    return 'status-pending';
  };
  
  return (
    <div className="admin-page">
      
      <div className="admin-header">
        <h1 className="brand-logo admin-brand-header" onClick={() => navigate('/admin/dashboard')} style={{ cursor: 'pointer' }} title="Yenile">
           <img src="/logo.png" width="50" alt="" />
           ARAS ASAF İNŞAAT – MUHASEBE
        </h1>
        
        <div className="date-time-info">
          {now.toLocaleDateString("tr-TR")} | {now.toLocaleTimeString("tr-TR")}
        </div>

        <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
            
            {/* ZİL 1: ALACAKLAR (Sadece acil olanların sayısı) */}
            <div style={{ position: "relative" }} onMouseEnter={() => setAlertOpen(true)} onMouseLeave={() => setAlertOpen(false)}>
                <div className="notification-wrapper">
                    <span className="notification-icon">🔔</span>
                    {bekleyenTaksitSayisi > 0 && ( <span className="notification-badge">{bekleyenTaksitSayisi}</span> )}
                </div>
                {alertOpen && (
                    <div className="alert-box">
                        <h4>Acil Tahsilat Durumu</h4>
                        <p style={{padding:'15px', textAlign:'center'}}>
                            {bekleyenTaksitSayisi > 0 
                                ? `${bekleyenTaksitSayisi} adet vadesi geçmiş/bugün olan tahsilat var.` 
                                : "Günü gelen acil tahsilat yok."}
                        </p>
                    </div>
                )}
            </div>

            {/* ZİL 2: BORÇLAR */}
            <div style={{ position: "relative" }} onMouseEnter={() => setPaymentAlertOpen(true)} onMouseLeave={() => setPaymentAlertOpen(false)}>
                <div className="notification-wrapper" style={{ borderColor: '#dc3545' }}>
                    <span className="notification-icon">💸</span>
                    {bekleyenOdemeSayisi > 0 && ( <span className="notification-badge" style={{backgroundColor:'#dc3545'}}>{bekleyenOdemeSayisi}</span> )}
                </div>
                {paymentAlertOpen && (
                    <div className="alert-box">
                        <h4 style={{backgroundColor:'#dc3545'}}>Acil Ödeme Durumu</h4>
                        <p style={{padding:'15px', textAlign:'center'}}>
                            {bekleyenOdemeSayisi > 0 
                                ? `${bekleyenOdemeSayisi} adet vadesi geçmiş/bugün olan ödeme var.` 
                                : "Günü gelen acil ödeme yok."}
                        </p>
                    </div>
                )}
            </div>

            <Link to="/" className="admin-button-secondary small">Çıkış Yap</Link>
        </div>
      </div>
      
      <div className="admin-controls">
        <Link to="/yeni-cari" className="admin-button">➕ YENİ CARİ OLUŞTUR</Link>
        <Link to="/cariler" className="admin-button" style={{backgroundColor: '#17a2b8'}}>👥 MÜŞTERİ LİSTESİ</Link>
        <Link to="/odemeler" className="admin-button" style={{backgroundColor: '#dc3545'}}>💸 GİDER LİSTESİ</Link>
      </div>

      {loading && <p className="loading-text">Veriler yükleniyor...</p>}
      
      {!loading && (
        <>
            {/* --- TABLO 1: BU AYIN TAHSİLATLARI --- */}
            <div className="admin-table-container">
                <h2 style={{ color: '#28a745' }}>
                    {buAyAdi} AYI TAHSİLAT GÜNDEMİ (GELEN PARALAR)
                </h2>
                <table className="admin-table">
                    <thead><tr><th>Müşteri</th><th>Tarih</th><th>Miktar</th><th>Durum</th></tr></thead>
                    <tbody>
                    {buAyTaksitler.map((t) => (
                        <tr key={t.id} className="table-row-clickable" onClick={() => handleRowClick(t.cariId)}>
                            <td>{t.cariAd}</td>
                            <td>{formatDate(t.odemeGunu)}</td>
                            <td>{formatCurrency(t.miktar)}</td>
                            <td>
                                <span className={getStatusClass(t)}>
                                    {t.durum === 'Bekliyor' && t.odemeGunu.toDate() < new Date() ? 'VADESİ GEÇTİ' : t.durum.toUpperCase()}
                                </span>
                            </td> 
                        </tr>
                    ))}
                    {buAyTaksitler.length === 0 && <tr><td colSpan="4" style={{ textAlign: 'center' }}>Bu aya ait kayıt bulunamadı.</td></tr>}
                    </tbody>
                </table>
            </div>

            {/* --- TABLO 2: BU AYIN ÖDEMELERİ --- */}
            <div className="admin-table-container" style={{marginTop: '30px'}}>
                <h2 style={{ color: '#dc3545' }}>
                    {buAyAdi} AYI ÖDEME GÜNDEMİ (GİDEN PARALAR)
                </h2>
                <table className="admin-table">
                    <thead><tr><th>Firma / Şahıs</th><th>Tarih</th><th>Miktar</th><th>Durum</th></tr></thead>
                    <tbody>
                    {buAyOdemeler.map((o) => (
                        <tr key={o.id} className="table-row-clickable" onClick={() => handleTedarikciClick(o.cariId)}>
                            <td>{o.firmaSahis}</td>
                            <td>{formatDate(o.odemeTarihi)}</td>
                            <td>{formatCurrency(o.miktar)}</td>
                            <td>
                                <span className={getGiderStatusClass(o)}>
                                    {o.durum === 'Bekliyor' && o.odemeTarihi.toDate() < new Date() ? 'VADESİ GEÇTİ' : o.durum.toUpperCase()}
                                </span>
                            </td> 
                        </tr>
                    ))}
                    {buAyOdemeler.length === 0 && <tr><td colSpan="4" style={{ textAlign: 'center' }}>Bu aya ait ödeme kaydı bulunamadı.</td></tr>}
                    </tbody>
                </table>
            </div>
        </>
      )}
    </div>
  );
}

export default AdminDashboard;